import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';

export const CreateBulkTicketValidationSchema = z.object({
  file: z.instanceof(File),
  spaceColumnId: z
    .string({ required_error: 'Column is required.' })
    .min(1, { message: 'Column is required.' }),
});
export type TCreateBulkTicketValidation = z.infer<typeof CreateBulkTicketValidationSchema>;
export type TCreateBulkTicketPayload = TCreateBulkTicketValidation;
export type TCreateBulkTicketResponse = ApiResponse<{
  message: string;
}>;
export const createBulkTicket = async (payload: TCreateBulkTicketPayload): Promise<TCreateBulkTicketResponse> => {
  const url = `/ticket/bulk-create/${payload.spaceColumnId}`;

  const formData = new FormData();
  formData.append('file', payload.file);

  
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };


  return axiosInstance.post(url, formData, config);
};

/**
 * Use Create Ticketing Ticket React-Query Hook
 */
type UseCreateBulkTicketMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof createBulkTicket, AxiosErrorCustom>;
};

/**
 * Use Create Ticketing Ticket React-Query Hook
 */
export const useCreateBulkTicketMutation = ({ mutationConfig }: UseCreateBulkTicketMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: createBulkTicket,
    ...restConfig,
  });
};
